import { Form, Formik } from 'formik';
import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { IAddEditFormProps } from '../../../models/forms/IForm';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';

interface IProps extends IAddEditFormProps<any> {
  printContents: string[];
  templateName: string;
}

const PrintContentForm = (props: IProps) => {
  const [copies, setCopies] = useState<number>(
    props.initialValues?.Copies || 1
  );

  const handleDecrement = () => {
    setCopies((prev) => Math.max(0, prev - 1));
  };

  const handleIncrement = () => {
    setCopies((prev) => prev + 1);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value);
    if (!isNaN(value) && value >= 0) {
      setCopies(value);
    }
  };

  const stringToHex = (text) => {
    var bytes = new TextEncoder().encode(text);
    return Array.from(bytes,
        byte => byte.toString(16).padStart(2, "0")
        ).join("");
  };

  return (
    <Formik
      initialValues={{ ...props.initialValues, Copies: copies }}
      enableReinitialize
      validateOnBlur={false}
      onSubmit={(values) => {
        props.submitHandler({
          ...values,
          Copies: copies,
          PrintContent: props.printContents,
          TemplateName: props.templateName,
        });
      }}
    >
      {(values) => (
        <Form className="print-form">
          {props.isLoading && <FormLoader loading={props.isLoading} contained />}
          <Modal.Body>
            <div className="form-group formSet m-0">
              <div className="row">
                <div className="col-4">
                  <Label
                    className="label-style col-form-label mt-1"
                    required={true}
                    label="copies"
                  />
                </div>
                <div className="col-6">
                  <div className="d-flex align-items-center calculation-box">
                    <button
                      type="button"
                      className="btn btn-secondary btn-increment"
                      onClick={handleDecrement}
                    >
                      -
                    </button>
                    <input
                      className="form-control text-center"
                      type="number"
                      name="Copies"
                      value={copies}
                      onChange={handleChange}
                      min={0}
                    />
                    <button
                      type="button"
                      className="btn btn-secondary btn-decrement"
                      onClick={handleIncrement}
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex justify-content-center">
              <div className="tab-action">
                <Button
                  variant="light-danger"
                  type="button"
                  onClick={(e) => props.onModalClosed()}
                  disabled={props.isLoading}
                >
                  <FormattedMessage id={'cancel'} />
                </Button>

                <Button
                  className="btn btn-secondary ms-3"
                  data-toggle="modal"
                  href={`didprint:${stringToHex(props.printContents)};${props.templateName};${copies}`}
                  onClick={() => {
                    props.onModalClosed();
                  }}
                  data-testid="modalbtn"
                >
                  <FormattedMessage id={'print'} />
                </Button>
              </div>
            </div>
          </Modal.Footer>
          {/* <ModalFooter
            id={props.id}
            onModalClosed={props.onModalClosed}
            isLoading={props.isLoading}
            saveNextBtn={'print'}
            backCancelBtn="cancel"
          /> */}
        </Form>
      )}
    </Formik>
  );
};

export default PrintContentForm;
